// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__ROLRo","disabled":"FileBtn_disabled__1Beux","warn":"FileBtn_warn___cA2t","fade":"FileBtn_fade__1TZvw"};